import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getSystem = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/system/`, {
        headers: { Authorization: token }
    });
};

export const updateSystem = async (formData) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/system/update`, {
        sales: formData.sales,
        active_users: formData.usersTotal,
    }, {
        headers: { Authorization: token }
    });
};